/* eslint-disable max-statements */
import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const Categories = ({
  className,
  data,
  onClickItem,
  selectedKey
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, data.map(({
    key,
    name,
    renderCategory
  }) => /*#__PURE__*/React.createElement("div", {
    key: key,
    className: classNames(styles.item, key === selectedKey ? styles.active : null),
    onClick: () => onClickItem({
      name,
      key,
      renderCategory
    })
  }, name))));
};

export default Categories;